module.exports = "/packs/images/lvp_partners~d30aa11e9f4bedf7215c6dcbca99b52e.png";